import React from "react";
import ReactDOM from "react-dom";
import configureApp from "./config.js";
import { RoutedApp } from "skeleton/App.js";

console.log(`React: ${React.version}`);
configureApp();

ReactDOM.render(<RoutedApp />, document.getElementById("root"));
